import { ACTION_TYPES } from './_actionTypes';

/**
 * Action creator for resetting `rows` state.
 * @returns {Object} dispatched action.
 */
export const clearData = () => {
	return {
		type: ACTION_TYPES.QUEUE_CLEAR_DATA,
	};
};

/**
 * Action creator for performing index search on `rows` state.
 * @param {String} value nullable value to filter against.
 * @returns {Object} dispatched action.
 */
export const indexRows = value => {
	return {
		type: ACTION_TYPES.QUEUE_ROWS_INDEX,
		payload: value,
	};
};

/**
 * Action creator for initializing new state and updating existing state within the existing store.
 * @param {Object} value properties to be added to or updated in the existing store.
 * @returns {Object} dispatched action.
 */
export const init = value => {
	return {
		type: ACTION_TYPES.QUEUE_INIT,
		payload: value,
	};
};

/**
 * Action creator for setting `loading` state.
 * @param {boolean} value whether to render root loading animation.
 * @returns {Object} dispatched action.
 */
export const setLoading = value => {
	return {
		type: ACTION_TYPES.QUEUE_LOADING,
		payload: value,
	};
};

/**
 * Action creator for setting `rows` state.
 * @param {Object[]} rows nullable array of `DataTable` `row` objects.
 * @returns {Object} dispatched action.
 */
export const setRows = (rows, merge = false) => {
	return {
		type: ACTION_TYPES.QUEUE_ROWS,
		payload: {
			rows: rows,
			merge: merge,
		},
	};
};

export const filterRows = payload => {
	return {
		type: ACTION_TYPES.QUEUE_FILTER_ROWS,
		payload: payload,
	};
};

/**
 * Action creator for sorting `rows` state.
 * @param {String} header `Value` property of `headers` state's element of interest.
 * @param {Number} sortOrder nullable direction of sort; 1 for ascending, -1 for descending, null for no sort.
 * @returns {Object} dispatched action.
 */
export const sortByHeader = (header, sortOrder) => {
	return {
		type: ACTION_TYPES.QUEUE_HEADER_SORT,
		payload: {
			header: header,
			sortOrder: sortOrder,
		},
	};
};

/**
 * Action creator for toggling @param row in `requestees`, `rows` state.
 *
 * @param {Object} row `DataTable` `row` object of interest.
 * @returns {Object} dispatched action.
 */
export const toggleRow = row => {
	return {
		type: ACTION_TYPES.QUEUE_ROW_TOGGLE,
		payload: row,
	};
};

/**
 * Action creator for toggling all `requestees`, `rows` state against @param event .
 *
 * @param {Event} e event object of change.
 * @param {Number} index index of action firing change in`actions` state.
 * @returns {Object} dispatched action.
 */
export const toggleRows = (e, index) => {
	return {
		type: ACTION_TYPES.QUEUE_ROWS_TOGGLE,
		payload: {
			e: e,
			index: index,
		},
	};
};
